import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import Clickable from '@prisjakt/ui-clickable';
import { animations, layout, styledUtils } from '@prisjakt/ui-base';
import PriceLabel from '@prisjakt/ui-price-label';
import ProductImage from '@prisjakt/ui-product-image';
import ProductCheckbox, {
  productCheckboxHoverStyle,
} from '@prisjakt/ui-product-checkbox';

const indicateNewColumnAnimation = animations.highlightNewContentAnimation();

export const TdLink = styled(Clickable)`
  cursor: pointer;
  display: inline;
  padding: ${layout.spacing.xxSmall} ${layout.spacing.xSmall};
  text-align: left;
`;

type TrProps = { selected?: boolean };
export const Tr = styled.tr<TrProps>`
  cursor: pointer;
  ${props =>
    props.selected &&
    css`
      ${TdLink}::before {
        ${styledUtils.overlay(props.theme.bg.productCompareLight)}
      }
    `}

  @media (pointer: fine) {
    &:hover {
      ${TdLink}::after {
        ${styledUtils.overlay()}
      }
    }
  }
  td:last-child a {
    padding-right: 0;
  }
`;

export const ProductNameTable = styled.h3`
  font: inherit;
  font-weight: 600;
  font-size: ${layout.measurements.fontSizeSmall};
  margin-bottom: 0;
  flex: 1;
`;

type RawTdProps = { indicateNewColumn?: boolean };
export const RawTd = styled.td<RawTdProps>`
  font-size: ${layout.measurements.fontSizeSmall};
  border-bottom: 1px solid ${({ theme }) => theme.lines.secondary};
  position: relative;
  & > a {
    display: block;
  }
  ${({ indicateNewColumn }) => indicateNewColumn && indicateNewColumnAnimation}
`;

export const Price = styled(PriceLabel)`
  font-size: ${layout.measurements.fontSizeNormal};
`;

const ImageLayout = css`
  height: 32px;
  width: 32px;
  margin-right: ${layout.spacing.xSmall};
`;

export const Image = styled(ProductImage)`
  ${ImageLayout}
`;

export const ImagePlaceholder = styled.div`
  ${ImageLayout}
`;

type TdProps = {
  children: ReactNode;
  to?: string;
  ariaLabel: string;
  dataTest?: string;
  indicateNewColumn?: boolean;
};
export const Td = ({
  children,
  to,
  ariaLabel,
  dataTest,
  indicateNewColumn,
  ...rest
}: TdProps) => (
  <RawTd indicateNewColumn={indicateNewColumn}>
    <TdLink to={to} aria-label={ariaLabel} data-test={dataTest} {...rest}>
      {children}
    </TdLink>
  </RawTd>
);

export const NameTd = RawTd;

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const NameLink = styled(TdLink)`
  && {
    box-sizing: border-box;
    display: flex;
    flex: 1 0 auto;
    max-width: 100%;
    align-items: center;
  }
`;

export const CampaignBadgeWrapper = styled.div`
  margin-left: ${layout.spacing.xSmall};
  min-width: 20px;
`;

export const PropertyTd = styled(Td)`
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CompareCheckbox = styled(ProductCheckbox)`
  margin-left: ${layout.spacing.xSmall};
  ${Tr}:hover & {
    ${productCheckboxHoverStyle}
  }
`;
